import { Alert, Snackbar } from "@mui/material";
import { useMemo } from "react";

type Props = {
  submitSucceeded: boolean;
  submitError: boolean;
  setSubmitSucceeded: (value: boolean) => any;
  setSubmitError: (value: boolean) => any;
  succeedMsg: string;
  failedMsg: string;
};

const ResultBar = (props: Props) => {
  const snackBar = useMemo(() => {
    return props.submitSucceeded ? (
      <Snackbar open={true} onClose={() => props.setSubmitSucceeded(false)}>
        <Alert severity="success" sx={{ margin: "auto" }}>
          {props.succeedMsg}
        </Alert>
      </Snackbar>
    ) : props.submitError ? (
      <Snackbar open={true} onClose={() => props.setSubmitError(false)}>
        <Alert severity="error" sx={{ margin: "auto" }}>
          {props.failedMsg}
        </Alert>
      </Snackbar>
    ) : (
      <></>
    );
  }, [props]);
  return snackBar;
};

export default ResultBar;
